import { SVGProps, Ref, forwardRef } from 'react';

export const MediumSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M12.544 1H3.456A2.456 2.456 0 0 0 1 3.456v9.088C1 13.9 2.1 15 3.456 15h9.088C13.9 15 15 13.9 15 12.544V3.456C15 2.1 13.9 1 12.544 1"
            fill="#919191"
        />
        <path
            d="M15 10.635v1.271q-.12.012-.246.012c-1.503 0-2.35-1.252-2.386-2.818a4 4 0 0 1 .005-.292l.004-.06.004-.062c.054-.691.277-1.307.644-1.762a2.27 2.27 0 0 1 1.785-.856h.013q.09 0 .177.006v.35a.8.8 0 0 0-.2-.028c-.633.014-1.01.772-1.057 1.823H15v.296h-1.285c-.059 1.024.502 1.89 1.285 2.12"
            fill="#E2E2E2"
        />
        <path
            d="m12.431 4.345.011-.003v-.085h-2.254l-2.094 4.92-2.093-4.92H3.57v.085l.011.003c.412.092.62.23.62.73v5.85c0 .499-.21.637-.62.73l-.012.003v.085H5.22v-.085l-.011-.003c-.412-.093-.62-.231-.62-.73v-5.51l2.689 6.328h.152l2.768-6.505v5.83c-.035.395-.242.517-.615.601l-.011.003v.085h2.871v-.085l-.01-.003c-.374-.084-.586-.206-.621-.6l-.002-5.994h.002c0-.5.209-.638.62-.73"
            fill="#E2E2E2"
        />
    </svg>
));
MediumSize16Glyph.displayName = 'MediumSize16Glyph';
